import { render, staticRenderFns } from "./Sanitation.vue?vue&type=template&id=85a06d6e&scoped=true"
import script from "./Sanitation.vue?vue&type=script&lang=js"
export * from "./Sanitation.vue?vue&type=script&lang=js"
import style0 from "./Sanitation.vue?vue&type=style&index=0&id=85a06d6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a06d6e",
  null
  
)

export default component.exports